module.exports = __webpack_public_path__ + "static/img/08034D_2_R_20210930_LC.76c2ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08034D_2_R_20210930_LC.png
// module id = uG5j
// module chunks = 0